import React from 'react';
import styled from 'styled-components';

interface BadgeProps {
  content: string | JSX.Element;
  className?: string;
  varient?: 'warn' | 'info';
  active?: boolean;
  style?: React.CSSProperties;
}

const StyledBadge = styled.div<{ active: boolean; variant: 'warn' | 'info' }>`
  background-color: ${({ theme, active, variant }) =>
    variant === 'warn'
      ? theme.components.badge.warn.backgroundColor
      : active
        ? theme.components.badge.active.backgroundColor
        : theme.components.badge.success.backgroundColor};
  border-radius: 2px;
  margin-top: 4px;
  padding-left: 3px;
  padding-right: 3px;
  padding-top: 1px;
  padding-bottom: 1px;

  & h5 {
    color: ${({ theme, active, variant }) =>
      variant === 'warn' ? theme.text.warn : active ? theme.text.color : theme.components.badge.success.textColor};
    letter-spacing: 0.3px;
    font-size: 10px;
    font-weight: 300;
    margin-bottom: 0px;
    ${({ theme }) => theme.components.badge.fontWeight && `font-weight: ${theme.components.badge.fontWeight}  !important;`}
  }
`;

const Badge: React.FC<BadgeProps> = ({ content, className, varient = 'warn', active = false, style }) => (
  <StyledBadge className={className} variant={varient} active={active} style={style}>
    <h5>{content}</h5>
  </StyledBadge>
);

export default Badge;
